import { Component, OnInit } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { Router, ActivatedRoute } from "@angular/router";
import { DataService, PlayerService } from "/Users/curtis/Downloads/Listen.FM_Build_myself/source_4.2.2020/fm181/src/_services/index";

@Component({
  selector: "app-page",
  templateUrl: "./page.component.html"
})
export class PageComponent implements OnInit {
  page: any = {};
  constant: any = {};
  slug: string;
  station: any = {};

  constructor(
    private route: ActivatedRoute,
    private dataService: DataService,
    private router: Router,
    private playerService: PlayerService,
    private titleService: Title
  ) {
    this.slug = this.route.snapshot.params.slug;
  }

  ngOnInit() {
    this.init();
  }

  init() {
    if (this.slug) {
      this.dataService.callPages(this.slug).subscribe(
        result => {
          // Handle result
          console.log("call pages");
          console.log(result);
          if (result.status == "success") {
            this.titleService.setTitle(result.name + "- Listen.FM");
            this.page = result;
          } else {
            this.router.navigate(["/"]);
          }
        },
        error => {
          if (error.status == 404) {
            this.router.navigate(["/"]);
          }
          if (error.ok == false) {
            this.router.navigate(["/"]);
          }
        }
      );
    }

    this.constant = this.dataService.getConstant();
    if (Object.keys(this.constant).length === 0) {
      this.dataService.callConstants().subscribe(result => {
        this.constant = result;
      });
    }
  }
}
